// Endpoints centralizados — leídos de variables de entorno con fallback
// a las URLs de producción actuales para no romper despliegues existentes.
//
// Para sobreescribir, crear `.env.local` con:
//   REACT_APP_API_CREATE_PREFERENCE=https://...
//   REACT_APP_API_SEND_CONTACT=https://...
//   REACT_APP_API_ML_GET_ORDERS=https://...
//
// Reiniciar el dev server después de cambiar `.env.local`.

const env = (key, fallback) => {
  const v = process.env[key];
  return typeof v === "string" && v.trim() ? v.trim() : fallback;
};

export const API_URLS = {
  createPreference: env(
    "REACT_APP_API_CREATE_PREFERENCE",
    "https://createpreference-jizba2lz4q-uc.a.run.app"
  ),
  sendContactEmail: env(
    "REACT_APP_API_SEND_CONTACT",
    "https://sendcontactemail-jizba2lz4q-uc.a.run.app"
  ),
  mercadolibreGetOrders: env(
    "REACT_APP_API_ML_GET_ORDERS",
    "https://mercadolibregetorders-jizba2lz4q-uc.a.run.app"
  ),
  getBusinessAdvice: env(
    "REACT_APP_API_BUSINESS_ADVICE",
    "https://us-central1-techteno-1e8ad.cloudfunctions.net/getBusinessAdvice"
  ),
};

export default API_URLS;
